import { combineReducers } from "redux"
import { setterReducer } from "../common/redux"
import * as t from "./actionTypes"

export const cardIdentifier = setterReducer("", t.SET_CARD_IDENTIFIER)
export const showEmailModal = setterReducer(false, t.SHOW_EMAIL_MODAL)
export const configuredExperience = setterReducer("", t.SET_CONFIGURED_EXPERIENCE)
export const configuredPlanProvider = setterReducer("", t.SET_CONFIGURED_PLAN_PROVIDER)
export const canUpdateInsurance = setterReducer(false, t.SET_CAN_UPDATE_INSURANCE)

export const employer = setterReducer("", t.SET_EMPLOYER)
export const marketplaceToken = setterReducer("", t.SET_MARKETPLACE_TOKEN)
export const specialist = setterReducer(
  { display: "", name: "" },
  t.SET_SPECIALIST
)
export const diagnosisConcernSearch = setterReducer(
  "",
  t.SET_DIAGNOSIS_CONCERN_SEARCH
)
export const diagnosisConcernRecommendations = setterReducer(
  "",
  t.SET_DIAGNOSIS_CONCERN_REC
)
export const insuranceMessages = setterReducer([], t.SET_INSURANCE_MESSAGES)
export const didCaptureLocation = setterReducer(false, t.SET_DID_CAPTURE_LOCATION)

export const recommendationSections = (state = [], action) => {
  switch (action.type) {
    case t.SET_RECOMMENDATIONS:
      return action.payload
    default:
      return state
  }
}

export const zipcode = (state = "", action) => {
  switch (action.type) {
    case t.SET_ZIPCODE:
      if (action.payload.length > 32) return state
      else if (action.payload === "None") return ""
      else return action.payload
    default:
      return state
  }
}

export const zipcodeError = (state = false, action) => {
  switch (action.type) {
    case t.SET_ZIPCODE_ERROR:
      return action.payload
    default:
      return state
  }
}

const integration = combineReducers({
  zipcode,
  zipcodeError,
  recommendationSections,
  cardIdentifier,
  showEmailModal,
  configuredExperience,
  configuredPlanProvider,
  canUpdateInsurance,
  employer,
  marketplaceToken,
  specialist,
  diagnosisConcernSearch,
  diagnosisConcernRecommendations,
  insuranceMessages,
  didCaptureLocation
})

export { integration as default }



// WEBPACK FOOTER //
// ./assets/integration/reducer.js